
import {Component, ViewChild} from '@angular/core';
import {NavController, Tabs} from 'ionic-angular';

import { LoginPage } from "../login/login";
import { CliPage} from "../cli/cli";
import { GroupsPage } from '../groups/groups';
import { ElementsPage } from '../elements/elements';
import { DataPage } from '../data/data';
import { HandmadeQueriesPage} from "../handmade-queries/handmade-queries";


import { Storage } from '@ionic/storage';
import {ApiServiceProvider} from "../../providers/api.service";



@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {



  @ViewChild('mytabs') tabRef: Tabs;
  user : any;


  // loginTab =LoginPage;
  cliTab = CliPage;
  groupsTab= GroupsPage;
  elementsTab =ElementsPage;
  dataTab = DataPage;
  handmadeTab = HandmadeQueriesPage;
  constructor(
              public navCtrl: NavController,
              public storage: Storage,
              public api: ApiServiceProvider) {

    //check if user is logged in

    console.log(this.api.user);
    storage.get('userLoggedIn').then((user)=>{
        this.user=user;
      // this.storage.set('userLoggedIn', null);
    })



  }

  ionViewDidEnter(){

    this.tabRef.select(0);
  }

   gotoPage(page){

    switch(page){
      case 'login':
        this.navCtrl.pop();
        break;
      case 'cli':

        this.tabRef.select(0);
        break;
      case 'participants':
        this.tabRef.select(1);
        //this.root = GroupsPage;
        break;
      case 'assets':
        this.tabRef.select(2);
        // this.root = ElementsPage;
        break;
      case 'data':
        this.tabRef.select(3);
        // this.root = DataPage;
        break;
      case 'handmade-queries':
        this.tabRef.select(4);
        // this.root = HandmadeQueriesPage;
        break;


    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts